import { get } from 'svelte/store';
import { backend_url, access_token, storeLanguage, lang_fr } from './store';
import { storeArticles, storeMyArticles, storeArticlesError, storeArticle, storePartnerArticles } from './blog';
import { authentication } from './api';
import { addNotificationError } from "./toaster";
/**
 * getArticles
 * /articles/ - GET
 */
export async function getArticles() {
    const apiUrl = get(backend_url) + "v1/articles/";
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeArticles.set(data);
        storeArticlesError.set("");
        return true;
    })
        .catch((error) => {
        storeArticles.set([]);
        storeArticlesError.set(initError(error));
        return false;
    });
}
/**
 * incrementeRate
 *
 * @param $id
 */
export async function incrementRate($id) {
    const apiUrl = get(backend_url) + "v1/articles/incrementRate/";
    await authentication();
    const data = {
        id: $id
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        return true;
    })
        .catch((error) => {
        return false;
    });
}
/**
 * getArticlesOfAuthor
 * /articles/author/ - POST
 */
export async function getArticlesOfAuthor(idAuthor) {
    const apiUrl = get(backend_url) + "v1/articles/author/";
    await authentication();
    const data = {
        id: idAuthor
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeMyArticles.set(data);
        storeArticlesError.set("");
        return true;
    })
        .catch((error) => {
        storeMyArticles.set([]);
        storeArticlesError.set(initError(error));
        return false;
    });
}
/**
 * getArticlesOfPartner
 * /articles/partner/ - POST
 */
export async function getArticlesOfPartner(idPartner) {
    const apiUrl = get(backend_url) + "v1/articles/partner/";
    await authentication();
    const data = {
        id: idPartner
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storePartnerArticles.set(data);
        storeArticlesError.set("");
        return true;
    })
        .catch((error) => {
        storeMyArticles.set([]);
        storeArticlesError.set(initError(error));
        return false;
    });
}
/**
 * requestPublication
 *
 * @param $id
 */
export async function requestPublication($id) {
    const apiUrl = get(backend_url) + "v1/articles/requestpublication/";
    await authentication();
    const data = {
        id: $id
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        return true;
    })
        .catch((error) => {
        return false;
    });
}
/**
 * updateArticle
 * /users/id=$id - POST
 */
export async function updateArticle(id, title, subtitle, text, photoFile) {
    if (title == undefined || title == "" ||
        subtitle == undefined || subtitle == "" ||
        text == undefined || text == "") {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Merci de renseigner tous les champs");
        }
        else {
            addNotificationError("Please fill in all fields");
        }
        return false;
    }
    if (photoFile != undefined && photoFile != "") {
        const fileSize = Math.round((photoFile.size / 1024));
        if (fileSize > 999) {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("La taille de l'image doit être inférieure à 1Mo");
            }
            else {
                addNotificationError("Image size must be less than 1MB");
            }
            return false;
        }
    }
    const apiUrl = get(backend_url) + "v1/articles/?id=" + id;
    await authentication();
    let formData = new FormData();
    formData.append("id", id.toString());
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("text", text);
    formData.append("photoFile", photoFile);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: formData,
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeArticle.set(data);
        return true;
    })
        .catch((error) => {
        if (error == "Error: 422") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Données saisies invalides");
            }
            else {
                addNotificationError("Invalid data entered");
            }
            return false;
        }
        else {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Erreur");
            }
            else {
                addNotificationError("Error");
            }
            return false;
        }
    });
}
/**
 * addArticle
 * /users/
 */
export async function addArticle(id, title, subtitle, text, id_author, photoFile) {
    if (title == undefined || title == "" ||
        subtitle == undefined || subtitle == "" ||
        text == undefined || text == "" ||
        photoFile == undefined || photoFile == "") {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Merci de renseigner tous les champs et la photo de couverture");
        }
        else {
            addNotificationError("Please fill in all fields and cover photo");
        }
        return false;
    }
    const fileSize = Math.round((photoFile.size / 1024));
    if (fileSize > 999) {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("La taille de l'image doit être inférieure à 1Mo");
        }
        else {
            addNotificationError("Image size must be less than 1MB");
        }
        return false;
    }
    const apiUrl = get(backend_url) + "v1/articles/";
    await authentication();
    let formData = new FormData();
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("text", text);
    formData.append("id_author", id_author);
    formData.append("photoFile", photoFile);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: formData,
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeArticle.set(data);
        return true;
    })
        .catch((error) => {
        if (error == "Error: 422") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Données saisies invalides");
            }
            else {
                addNotificationError("Invalid data entered");
            }
            return false;
        }
        else {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Erreur");
            }
            else {
                addNotificationError("Error");
            }
            return false;
        }
    });
}
/**
 * initError
 * @param errorStatus
 * @returns
 */
function initError(errorStatus) {
    let returnValue = "";
    if (errorStatus == "Error: 400") {
        returnValue = "Missing parameters";
    }
    else if (errorStatus == "Error: 401") {
        returnValue = "Unauthorized";
    }
    else if (errorStatus == "Error: 404") {
        returnValue = "Not found";
    }
    else if (errorStatus == "Error: 422") {
        returnValue = "Unprocessable entity";
    }
    else {
        returnValue = "Error";
    }
    return returnValue;
}
